import React from 'react'
import { gql, useQuery,
} from '@apollo/client';
import { GuestListTableContainer } from '../../dues/dues.style';
import { PageContainerTitleText } from '../../../../../widget/styledComponents/headings.style';
import {
  TableHead,
  TableBodyRow
} from './../../../../../widget/styledComponents/table.style'
import Cookies from 'js-cookie';
import { Spinner } from 'evergreen-ui';
import {useHistory } from 'react-router-dom';
import StatusPill from './statusPill';
import StatusPill2 from './statusPill2';
import AddAssetsPlaceholder from '../../../../../widget/add_assets_placeholder';
import { formatDate } from '../../../../../widget/util';


export const FETCH_COMPLAINT = gql`
query Complaints_getByFacility($facilityId: ID!) {
  complaints_getByFacility(facilityId: $facilityId) {
    _id
    createdAt
    title
    facility
    property {
      _id
      facility
      type
      address
      numberOfRooms
      squareMeter
      createdAt
      resident {
        name
      }
      owner {
        name
      }
    }
    id
    status
    createdBy {
      _id
      name
      email
      address
    }
    resolved
  }
}

`;

function ComplaintsWidget() {
  const facilityId = Cookies.get('facilityId');

  return (
    <div>
        <GuestListTableContainer 
          style={{
            height:"520px",
            overflow: "auto",
          }}
        >
            <PageContainerTitleText>
              Complaint
            </PageContainerTitleText>
            <table className='responsive-table'>
                <thead>
                  <tr>
                      <TableHead>Title</TableHead>
                      <TableHead>Resident Names</TableHead>
                      <TableHead>House No</TableHead>
                      <TableHead>Date</TableHead>
                      <TableHead>Status</TableHead>
                      <TableHead>User Feedback</TableHead>

                  </tr>
                </thead>
                {facilityId === undefined
                  ? <p></p>
                  :<Complaints/>
                }
            </table>
                 <center> <AddAssetsPlaceholder/></center>
                
            
        </GuestListTableContainer>
    </div>
  )
}

export default ComplaintsWidget




function Complaints() {
const facilityId = Cookies.get('facilityId');

const history = useHistory()
const { loading,error,data }  = useQuery(FETCH_COMPLAINT,{
  variables:{
    facilityId
  }
});

console.log("fac",facilityId)

if (loading) return <Spinner/>;
if (error) return <p>Error: {error.message}</p>;
const complaint = data.complaints_getByFacility

  return (
    <tbody>
                  
      {data && 
        complaint.map((comp)=><TableBodyRow
          onClick={()=>history.push(`/complaintById/${comp._id}`)}
        >
          <td>{comp.title}</td>
          <td>
            {comp.createdBy &&  comp.createdBy.name}
          </td>
          <td>{comp.createdBy &&  comp.createdBy.address}</td>
          {/* <td>{comp.createdAt}</td> */}
          <td>{formatDate(comp.createdAt)}</td>
          <td><StatusPill status={comp.status}/></td>
          <td><StatusPill2 status={comp.resolved}/></td>
          </TableBodyRow>
        )
      }
      
    </tbody>
  )
}




  

